import React from 'react';

import { Box, Button, Divider, Header, Text } from '@rbilabs/universal-components';

import {
  EnvItem,
  EnvList,
  EnvListContainer,
  HiddenSection,
  ServiceModeItem,
} from 'pages/diagnostics/components';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { useStoreContext } from 'state/store';
import AuthStorage from 'utils/cognito/storage';
import crashlytics from 'utils/crashlytics';
import { StorageKeys } from 'utils/local-storage';

import { ConfigSettings, ExperimentFlags, LDFlags, LocalStorageItems } from './components';

export const InternalDiagnostics = () => {
  const enableInternalDiagnosticTools = useFlag(LaunchDarklyFlag.ENABLE_INTERNAL_DIAGNOSTIC_TOOLS);

  const { noStoreSelected, serviceModeStatus } = useStoreContext();

  if (!enableInternalDiagnosticTools) {
    return null;
  }

  return (
    <>
      <Header pt={4} variant="headerFour">
        User Auth Info
      </Header>
      <EnvItem envKey="Auth Token" value={AuthStorage.getItem(StorageKeys.USER_AUTH_TOKEN)} />
      <Divider />
      <Divider />
      <ExperimentFlags />
      <Divider />
      <ConfigSettings />
      <Divider />
      <LDFlags />
      <Divider />
      <LocalStorageItems />
      <Divider />
      <HiddenSection
        title="Force Crash App"
        content={
          <>
            <Text marginBottom={'$5'}>
              Force Crash the App. Useful for testing crash handling, logging or other situations.
            </Text>
            <Button onPress={() => crashlytics().crash()}>Force Crash App</Button>
          </>
        }
      />
      <Divider />
      <Header pt={4} variant="headerThree">
        Store Info
      </Header>
      {!noStoreSelected ? (
        <>
          <Header variant="headerFour">Store Service Modes Availability</Header>
          <EnvListContainer>
            <EnvList
              data={serviceModeStatus}
              renderItem={(key, value) => <ServiceModeItem envKey={key} value={value} />}
            />
          </EnvListContainer>
        </>
      ) : (
        <Box>No store selected</Box>
      )}
    </>
  );
};
